module.exports = __webpack_public_path__ + "img/tool_pen_active.c0f92637.png";